import { IChildrenProps } from '@/typings/children-props'
import { cn } from '@/utils/styles/cn'

interface IInteractiveCitiesSearchListContainerProps extends IChildrenProps {
    className?: string
}

export const InteractiveCitiesSearchListContainer = ({
    children,
    className,
}: IInteractiveCitiesSearchListContainerProps) => {
    return (
        <div
            className={cn('w-full min-w-0 md:flex-1 pt-8 md:pt-14 pb-10 md:pb-14 flex', className)}
        >
            <div className="w-full flex flex-col">{children}</div>
        </div>
    )
}
